export default __webpack_public_path__ + "static/media/halal.56d97527.svg";